module.exports = __webpack_public_path__ + "img/410.6ed9edaa.png";